import { connect } from 'react-redux';
import { DefaultButton, Label, Link, Separator, Spinner, Text } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// styles
import './CommissionAgentAssociated.Styles.css';


// component functions
import * as ComponentFunctions from './CommissionAgentAssociated.Functions';

// components
import { ErrorMessageComponent } from '../../Error/ErrorMessageComponent';
import { CommissionAgentAssociatedItemComponent } from './CommissionAgentAssociatedItem.Component';

// models
import { ContractCommissionAgent } from '../../../models/Entities/Contracts/ContractCommissionAgent';
import { useNavigate } from 'react-router-dom';

const CommissionAgentAssociatedComponent = (props: ComponentFunctions.Props) => {

    const Navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        props.GetCommissionAgentsByAssociatedContractId(props.ContractId);
        props.GetAllPractitioners(1, 10000, '');
    }, [props.ContractId]);

    const Messages = props.Contract?.FailGettingCommissionAgentContractAssociation === true && (
        <>
            <ErrorMessageComponent Error={props.Contract?.ErrorGettingCommissionAgentContractAssociation} />
        </>
    );

    const Loading = props.Contract?.isGettingCommissionAgentContractAssociation === true && (
        <>
            <div>
                <Spinner
                    label={t('CommissionAgentAssociated.loading')}
                    ariaLive="assertive"
                    labelPosition="top"
                />
            </div>
        </>
    );


    return (
        <div>
            {Messages}
            {Loading}
            {props.Contract?.GettingCommissionAgentContractAssociationSuccess === true && (props.Contract?.commissionAgentsAssociated || []).length > 0 && (
                <>
                <p>
                <Label>{t('CommissionAgentAssociated.associatedProfessionals')}</Label>
                </p>
                {props.Contract?.commissionAgentsAssociated?.map((commissionAgent: ContractCommissionAgent) => {
                    return (
                        <div key={'CAA_' + commissionAgent.id.toString()} className='ContractAgentAssociationItem'>
                            <CommissionAgentAssociatedItemComponent commissionAgent={commissionAgent} practitioner={props.GetPractitioner(commissionAgent.commissionAgentId)} />
                            <Link target='_blank'  href={window.location.origin + '/contracts/' + commissionAgent.contractId}>{t('CommissionAgentAssociated.goToContract')}</Link>
                        </div>
                    )
                })}
                </>
            )}
        </div>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(CommissionAgentAssociatedComponent as any); 